import { z } from "zod";
import { doubleEncode, makeGetRequest } from "../../utils";

const RecordingFile = z.object({
	id: z.string(),
	recording_start: z.string(),
	recording_end: z.string(),
	file_type: z.string(),
	file_size: z.number(),
	download_url: z.string(),
	status: z.string(),
	deleted_time: z.optional(z.string()),
	recording_type: z.string(),
});

const ParticipantVideoFile = z.object({
	id: z.string(),
	recording_start: z.string(),
	recording_end: z.string(),
	file_name: z.string(),
	file_type: z.string(),
	file_extension: z.string(),
	file_size: z.number(),
	download_url: z.string(),
	recording_type: z.string(),
	status: z.string(),
	user_id: z.string(),
	user_key: z.string(),
});

const ParticipantAudioFile = z.object({
	id: z.string(),
	recording_start: z.string(),
	recording_end: z.string(),
	file_name: z.string(),
	file_type: z.string(),
	file_extension: z.string(),
	file_size: z.number(),
	download_url: z.string(),
	status: z.string(),
	user_id: z.string(),
	user_key: z.string(),
});

const Session = z
	.object({
		session_id: z.string(),
		session_name: z.string(),
		start_time: z.string(),
		duration: z.number(),
		total_size: z.number(),
		recording_count: z.number(),
		recording_files: z.array(RecordingFile),
		participant_video_files: z.array(ParticipantVideoFile),
		download_access_token: z.string(),
		participant_audio_files: z.array(ParticipantAudioFile),
	})
	.deepPartial();

type Session = z.infer<typeof Session>;

type ListSessionRecordingsOptions = {
	sessionId: string;
	include_fields?: string;
	ttl?: number;
};
const listSession_sRecordings = async (
	token: string,
	options: ListSessionRecordingsOptions,
): Promise<Session> => {
	const res = await makeGetRequest({
		token,
		pathList: [
			"v2",
			"videosdk",
			"sessions",
			doubleEncode(options.sessionId),
			"recordings",
		],
		options: { ...options },
	});
	const parsed = Session.parse(res);
	return parsed;
};

export const curriedListSession_sRecordings = (token: string) => (
	options: ListSessionRecordingsOptions,
) => listSession_sRecordings(token, options);
